module.exports = __webpack_public_path__ + "img/la-memorial-coliseum_2.874ab97a.jpg";